<template>
  <div class="d-flex align-items-center">
    <Avatar
      :avatar="avatar"
      :name="username"
      v-if="username"
    />

    <div class="pl-2" v-if="username">
      <strong class="d-block">{{ username }}</strong>
      {{ companyName }}
    </div>
  </div>
</template>

<script>
import Avatar from './Avatar.vue';

export default {
  props: {
    username: String,
    companyName: String,
    avatar: String,
  },

  components: {
    Avatar,
  },
};
</script>
